import React, { useState, useEffect } from "react";

const ProgressIndicator = () => {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            // Show indicator after scrolling 100px
            setIsActive(scrollPosition > 100);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const styles = {
        progressIndicator: {
            position: "fixed",
            right: "26px",
            bottom: "35px",
            height: "50px",
            width: "50px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), inset 0 0 0 2px var(--uniqo-primary)",
            zIndex: 9999,
            backgroundColor: "Transparent",
            opacity: isActive ? 1 : 0,
            visibility: isActive ? "visible" : "hidden",
            transform: isActive ? "translateY(0)" : "translateY(15px)",
            transition: "all 200ms ease-in-out",
        },
        icon: {
            fontSize: "20px",
            color: "var(--uniqo-secondary)",
            lineHeight: 1,
        },
    };

    return (
        <div style={styles.progressIndicator} onClick={handleClick}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--uniqo-secondary)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="18 15 12 9 6 15" />
            </svg>
        </div>
    );
};

export default ProgressIndicator;
